<template>
    <div class="cz2__panel cz2__panel--secondary cz2__panel--secondary-fullscreen cz2__product-details">
        <focus-lock :disabled="focusLockDisabled">
            <div class="cz2__panel__header">
                <details-header></details-header>
            </div>

            <template v-if="hasOwnContent">
                <div class="cz2__panel__body cz2__panel__body--with-html">
                    <section v-if="shortDescription || longDescription">
                        <header>{{$t('PRODUCT_INFO_DESCRIPTION')}}</header>

                        <p v-if="longDescription">
                            <span v-html="longDescription"></span>
                        </p>

                        <p v-if="!longDescription && shortDescription">
                            <span v-html="shortDescription"></span>
                        </p>
                    </section>

                    <section v-if="features && features.length > 0">
                        <header>{{$t('PRODUCT_INFO_FEATURES')}}</header>

                        <ul>
                            <li v-for="f in features" :key="f"><span v-html="f"></span></li>
                        </ul>
                    </section>

                    <section>
                        <header>{{$t('PRODUCT_INFO_PRICING')}}</header>

                        <p>
                            {{$t('PRODUCT_INFO_PRICING_COPY')}}
                        </p>

                        <ul>
                            <li v-for="f in priceLevels" :key="f">{{f}}</li>
                        </ul>
                    </section>
                </div>
            </template>

            <template v-else>
                <div class="cz2__panel__body cz2__panel__body--with-html">
                    <div v-html="content"></div>
                </div>
            </template>

            <div class="cz2__panel__actions">
                <button class="cz2__panel-action cz2__panel-action--cancel" @click.prevent="cancel"><span>{{$t('MENU_BACK')}}</span></button>
            </div>
        </focus-lock>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
    }
</style>

<script>
    import FocusLock from 'vue-focus-lock';

    import DetailsHeader from './DetailsHeader.vue';

    export default {
        components: {
            FocusLock,
            DetailsHeader,
        },
        data() {
            return {
                focusLockDisabled: true,
            };
        },
        computed: {
            /**
             * Current view controller.
             */
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            /**
             * Retrives panel content.
             */
            content() {
                if (this.viewController == null) {
                    return '';
                }

                return this.viewController.blueprint.custom['v-product-details-html'] || '';
            },

            /**
             * Does product has own content.
             */
            hasOwnContent() {
                return this.viewController
                    && this.viewController.blueprint.custom['v-short-description']
                    && this.viewController.blueprint.custom['v-short-description'].length > 0;
            },

            shortDescription() {
                const v = this.viewController
                    && this.viewController.blueprint.custom['v-short-description'];

                return v && v.length > 0 ? v : null;
            },

            longDescription() {
                const v = this.viewController
                    && this.viewController.blueprint.custom['v-long-description'];

                return v && v.length > 0 ? v : null;
            },

            features() {
                let v = this.viewController
                    && this.viewController.blueprint.custom['v-features'];

                if (v) {
                    const features = [];

                    if (!v.startsWith('[')) {
                        v = [v];
                    } else {
                        v = JSON.parse(v);
                    }

                    v.forEach((line) => {
                        const split = line.split('\n').map((l) => l.trim());

                        split.forEach((l) => {
                            features.push(l);
                        });
                    });

                    return features;
                }

                return null;
            },

            priceLevels() {
                if (this.viewController == null) {
                    return [];
                }

                const { priceTiers } = this.$store.getters;

                return priceTiers.map((p, index) => {
                    const last = index === priceTiers.length - 1;

                    return this.$t('PRODUCT_INFO_PRICING_COPY_DETAILS', {
                        units: last ? `${p.quantity}+` : p.quantity,
                        save: p.formatted ?? p.amount,
                    });
                });
            },
        },
        mounted() {
            // Otherwise this messes with transition animation because browsers will try to scroll to the focused item, which would be off-screen.
            this.$store.state.eventBus.$once('secondaryEntered', () => {
                // this.focusLockDisabled = false;
            });

            this.$el.addEventListener('click', this.aClick);
        },
        beforeDestroy() {
            this.$el.removeEventListener('click', this.aClick);
        },
        methods: {
            /**
             * Go back.
             */
            cancel() {
                // Go back to the main screen.
                this.$store.dispatch('selectStep', null);
            },

            aClick(e) {
                if (e.target && e.target.tagName === 'A') {
                    if (e.target.target === '_blank' && e.target.href && e.target.href.length > 0) {
                        window.open(e.target.href);
                    }
                }
            },
        },
    };
</script>
